<div style="width: 100%" class="d-flex flex-column align-items-center justify-content-between">
  <app-admin-header *ngIf="!isChild" style="width: 100%" [header]="header" [links]="links" [breadcrumbs]="breadcrumbs"
    [queryParams]="queryParams" [stats]="stats"></app-admin-header>
  <div class="w-100">
    <!-- skelition   -->
    <app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
  </div>
  <div id="result-parent" class="container-fluid mb-2 p-10-px 222" *ngIf="!skelition">
    <div class="content-bg-2" [hidden]="from !== 'assessment'">
      <app-assessment-result-module [from]="from" class="pt-4" [assessmentIds]="[assessmentId]"
        [totalMarks]="(assessment ) ? assessment.totalMarks : 0"
        (getGradesData)="totalGradesData = $event"></app-assessment-result-module>
    </div>

    <div class="container-fluid">
      <div class="row">
        <h4 class="color-grey my-3">{{ (from == 'assessment') ? ("testers information" | translator) : ('testers
          information Survey' | translator) }}</h4>
        <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-0 p-0">
          <p-tabView class="v4-bg-white v4-dsbrd-btns" [activeIndex]="activeResultTabIndex"
            (onChange)="onTabChange($event)">
            <p-tabPanel *ngIf="assessment != undefined && assessment.accessType == 'BY_ACCOUNT'"
              class="v4-bg-white v4-dsbrd-btns" header="{{ 'Invitees' | translator }}">
              <div *ngIf="showInviteDropdown || isFilterApplied"
                class="d-flex justify-content-center align-items-center flex-wrap gap-2">
                <div class="p-inputgroup my-3">
                  <span class="p-input-icon-right w-100">
                    <i class="pi pi-search"></i>
                    <input type="text" class="p-inputtext-lg sstarabic w-100 input-result" pInputText
                      placeholder="{{ 'Discus' | translator }}" (keydown.enter)="navigateToSearch($event)"
                      [(ngModel)]="searchText" />
                  </span>
                </div>
                <div>
                  <p-dropdown class="ppp-dropdown" [options]="types" [(ngModel)]="dropType" optionLabel="label"
                    appendTo="body" (onChange)="onChangeDropdown()"
                    [placeholder]="'Select User Type' | translator"></p-dropdown>
                </div>
                <button class="my-3 py-2 v4-btn-every" (click)="resetFilters()">
                  <i class="pi pi-refresh"></i>
                </button>
              </div>
              <app-user-table [data]="filteredInvitees" [loading]="skelition" [messages]="messages"
                [columns]="['the name', 'E-mail', 'Contact', 'Gender']" [action]="0" [goBackBtn]="false" [first]="first"
                [rows]="rows" [pagging]="true" [assessmentId]="assessmentId" [totalCount]="totalInvitees" [from]="from"
                (pageChange)="onPageChange($event,0)" (selectedUsersChange)="handleSelectedUsersChange($event)">
                ></app-user-table>
            </p-tabPanel>
            <p-tabPanel header="{{ 'Results' | translator }}">
              <div *ngIf="showResultDropdown || isFilterApplied"
                class="d-flex justify-content-center align-items-center flex-wrap gap-2">
                <div>
                  <p-dropdown class="ppp-dropdown" [options]="types" [(ngModel)]="dropType" optionLabel="label"
                    appendTo="body" (onChange)="onChangeDropdown()"
                    [placeholder]="'Select User Type' | translator"></p-dropdown>
                </div>
                <button class="my-2 py-2 v4-btn-every" (click)="resetFilters()"><i class="pi pi-refresh"></i></button>
                <button class="my-2 py-2 v4-btn-every" style="background-color:  #dc3545 ;" (click)="deleteUsers()"><i
                    class="pi pi-trash"></i>
                </button>
                <button type="button" pButton icon="pi pi-download" label="{{'Download' | translator}}"
                  class="my-2 v4-btn-every export-dropdown" (click)="exportMenu.toggle($event)"
                  [disabled]="downloadExcel || downloadPdfExcel || downloadPdf || exportingPPT || downloadExcelCache || downloadCWExcel">
                </button>

                <p-menu #exportMenu [model]="exportMenuItems" [popup]="true" appendTo="body"></p-menu>
                <p-progressSpinner class="v4-spin"
                  *ngIf="downloadExcel || downloadPdfExcel || downloadPdf || exportingPPT || downloadExcelCache || downloadCWExcel"
                  ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="!regenAttempt" [pTooltip]=" 'Regenerate Results' | translator"
                  class="my-2 py-2 v4-btn-every" (click)="regenerateAttempts()"><i
                    class="fa-solid fa-square-poll-vertical"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="regenAttempt" ariaLabel="loading"></p-progressSpinner>
                <button *ngIf="!sendCert && from == 'assessment'" [pTooltip]=" 'Send Certificate' | translator"
                  class="my-2 py-2 v4-btn-every" (click)="sendCertificate()">
                  <i class="fa-solid fa-certificate"></i>
                </button>
                <p-progressSpinner class="v4-spin" *ngIf="sendCert" ariaLabel="loading"></p-progressSpinner>
                <button class="my-2 py-2 v4-btn-every" (click)="emailModal = true"><i
                    class="pi pi-envelope"></i></button>
                <div class="p-inputgroup my-2">
                  <span class="p-input-icon-right w-100">
                    <i class="pi pi-search"></i>
                    <input type="text" class="p-inputtext-lg sstarabic w-100 input-result" pInputText
                      placeholder="{{ 'Discus' | translator }}" (keydown.enter)="navigateToSearch($event)"
                      [(ngModel)]="searchText" />
                  </span>
                </div>
              </div>
              <app-user-table [data]="filteredResults" [loading]="skelition" [messages]="messages" [columns]="
                  from == 'assessment'
                    ? [
                        'the name',
                        'E-mail',
                        'Contact',
                        'Gender',
                        'Score / Total Marks',
                        'Percentage',
                        'timeTaken',
                        'attempts',
                        'submittedTime',
                        'Result'
                      ]
                    : ['the name', 'E-mail', 'Contact', 'Gender', 'submittedTime']
                " [action]="2" [goBackBtn]="false" [first]="first" [rows]="rows" [pagging]="true"
                [assessmentId]="assessmentId" [totalCount]="totalUserResults" [from]="from"
                (pageChange)="onPageChange($event,1)" (updateDataEvent)="ngOnInit()"
                (selectedUsersChange)="handleSelectedUsersChange($event)">
                ></app-user-table>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>

    <div class="row v4-graph-bg" *ngIf="from != 'assessment'">
      <div class="container mb-3">
        <h4 class="color-grey">
          {{
          from == "assessment"
          ? ("statistics of each question of the test" | translator)
          : ("statistics of each question of the survey" | translator)
          }}
        </h4>
      </div>
      <app-no-data *ngIf="graphData.length <= 0"></app-no-data>

      <!-- Questions Grid — Bootstrap columns for reliable 3-up layout -->
      <div class="row g-3">
        <ng-container *ngFor="let data of graphData; let qi = index">
          <div class="col-lg-4 col-md-6 col-12" *ngIf="!noGraphs.includes(data.questionType)">
            <div class="question-card h-100">

              <!-- Icon badge — top-right corner -->
              <div class="q-icon-badge" [style.background]="getQuestionStyle(data).bgColor">
                <span [class]="getQuestionStyle(data).iconClass" 
                  [style.color]="getQuestionStyle(data).iconColor"
                  style="font-size: 1.15rem; display: flex; align-items: center; justify-content: center;"></span>
              </div>

              <!-- Question title -->
              <div class="q-title-row">
                <span class="q-number">{{ qi + 1 }}.</span>
                <h6 class="q-text">{{ data.questionText | translator }}</h6>
              </div>

              <!-- BAR CHART -->
              <div *ngIf="data.type === 'bar'" class="chart-wrap">
                <p-chart type="bar" [data]="data.graphData" [options]="barChartOptions" height="220"></p-chart>
              </div>

              <!-- TEXT TABLE -->
              <div *ngIf="data.type === 'text'" class="text-table-wrap">
                <div *ngIf="data.questionType === 'OU_TREE_DROPDOWN' && data.graphData" class="mb-3">
                  <p-chart type="bar" [data]="data.graphData" [options]="barChartOptions" height="220"></p-chart>
                </div>
                <p-table [columns]="data.data.labels" [value]="data.data.datasets[0].data"
                  [tableStyle]="{ 'min-width': '100%' }">
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th class="text-center">#</th>
                      <th *ngFor="let col of columns">{{ col }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-columns="columns" let-ri="rowIndex">
                    <tr>
                      <td class="text-center row-index">{{ ri + 1 }}</td>
                      <td *ngFor="let col of columns; let i = index">
                        <span class="text-answer">{{ (rowData && rowData[i] !== '' && rowData[i] !== null) ? rowData[i] : '—' }}</span>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>

              <!-- CALENDAR -->
              <div *ngIf="data.type === 'calander'" class="calendar-wrap">
                <table class="w-100 calendar-table">
                  <thead>
                    <tr><th>#</th><th>{{ 'Date' | translator }}</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of data.meta; let ci = index">
                      <td>{{ ci + 1 }}</td>
                      <td>{{ formatDate(row.value) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- TABLE (MATRIX/MULTIPOINT) -->
              <div *ngIf="data.type === 'table'" class="text-table-wrap">
                <p-table [value]="data.data.datasets" class="p-datatable-sm" [tableStyle]="{ 'min-width': '100%' }">
                  <ng-template pTemplate="header">
                    <tr>
                      <th></th>
                      <th *ngFor="let col of data.data.labels">{{ col }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr>
                      <td>{{ row.label }}</td>
                      <td *ngFor="let val of row.data">{{ val }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>

              <!-- SMILE / EMOJI -->
              <div *ngIf="data.type === 'smile'" class="smile-wrap">
                <div class="smile-grid">
                  <div class="smile-item" *ngFor="let item of data.graphData; let si = index">
                    <div class="smile-emoji-wrap">
                      <img [src]="getSmileIcon(item.label, si)"
                        style="width:40px;height:40px;object-fit:contain;"
                        alt="{{ item.label }}"
                        onerror="this.src='assets/results-icons/smile-emoji.png'" />
                    </div>
                    <div class="smile-label">{{ item.label | translator }}</div>
                    <div class="smile-count">{{ item.count }}%</div>
                  </div>
                </div>
              </div>

              <!-- STAR RATING -->
              <div *ngIf="data.type === 'rate'" class="rate-wrap">
                <div class="rate-row" *ngFor="let item of data.graphData">
                  <div class="rate-stars">
                    <p-rating class="v4-ratting" [disabled]="true" [(ngModel)]="item.value"
                      [cancel]="false"></p-rating>
                  </div>
                  <span class="rate-label">{{ item.label | translator }}</span>
                </div>
              </div>

              <!-- IMAGE CHOICE (SELECT_MANY_IMAGE) -->
              <div *ngIf="data.type === 'image-choice'" class="image-choice-wrap">
                <div class="image-choice-grid">
                  <div class="image-choice-item" *ngFor="let opt of data.imageOptions"
                    [class.image-choice-item--selected]="opt.selected">
                    <div class="image-choice-check" *ngIf="opt.selected">
                      <img src="assets/results-icons/checkmark.png" class="checkmark-icon" alt="selected" />
                    </div>
                    <div class="image-choice-check image-choice-check--empty" *ngIf="!opt.selected"></div>
                    <img [src]="opt.image" class="image-choice-img" alt="{{ opt.label }}"
                      onerror="this.src='assets/results-icons/mountain.png'" />
                    <div class="image-choice-label">{{ opt.label | translator }}</div>
                    <div class="image-choice-pct" *ngIf="opt.selected">{{ opt.percentage }}%</div>
                  </div>
                </div>
              </div>

              <!-- RANK ORDER / DRAG DROP -->
              <div *ngIf="data.type === 'rank_order'" class="rank-order-wrap">
                <table class="w-100 rank-table">
                  <thead>
                    <tr>
                      <th>{{ "Item" | translator }}</th>
                      <th *ngFor="let r of data.graphData?.ranks">
                        {{ "Rank" | translator }} {{ r }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let label of data.graphData?.labels">
                      <td class="rank-item-label">{{ label }}</td>
                      <td *ngFor="let r of data.graphData?.ranks">
                        {{ data.graphData?.distribution[label][r] || 0 }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </ng-container>
      </div>
    </div>
    </div>
  </div>
<app-footer *ngIf="!isChild"></app-footer>
<p-dialog [header]="'Add User to Survey' | translator" [maximizable]="true" [(visible)]="emailModal"
  [style]="{ width: '60vw' }">
  <div class="form-group mt-2">
    <div class="d-flex column label-score mb-2">
      <span class="label-ui">{{ "Email Text" | translator }}</span>
    </div>
    <textarea [(ngModel)]="emailText" [required]="true" class="w-100 input-ui" [style.height.px]="180">
    </textarea>
  </div>
  <div class="form-group mt-2">
    <div class="d-flex column label-score mb-2">
      <span class="label-ui">{{ "Link" | translator }}</span>
    </div>
    <input type="text" [(ngModel)]="emailLink" class="form-control input-ui">
  </div>
  <div class="mt-4" align="center">
    <button class="v4-btn-every" (click)="sendEmail()">
      <i class="pi pi-check">&nbsp;</i>{{ "Send Mail" | translator }}
    </button>
  </div>
</p-dialog>
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<div id="printable-area" *ngIf="printableData"
  style="display: none; direction: rtl; font-family: 'DINNextLTArabic'; color: #000 !important; background: #fff !important; width: 100%;">

  <!-- Cover Page -->
  <div
    style="height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; page-break-after: always; padding: 0 60px; box-sizing: border-box;">
    <img src="assets/new-logo/SCBCLOGO-COLOR.svg" style="width: 300px; margin-bottom: 50px;">
    <h1 style="font-size: 36px; margin-bottom: 20px; max-width: 100%; text-align: center; word-break: break-word; line-height: 1.3;">{{ printableData.assessmentName }}</h1>
    <h2 style="font-size: 24px; color: #666; max-width: 100%; text-align: center; word-break: break-word;">{{ printableData.subtitle }}</h2>
    <div style="margin-top: 100px; font-size: 18px;">{{ printableData.date }}</div>
  </div>

  <div style="padding: 20px 40px;">

    <!-- PDF Header (on every page except cover) -->
    <div class="pdf-header"
      style="display: flex; justify-content: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 30px;">
      <div style="font-weight: bold; font-size: 1.2rem;">{{ printableData.assessmentName }} | {{
        printableData.date }}</div>
    </div>

    <!-- 1. General information -->
    <div class="mb-5 pb-4 border-bottom">
      <h2 style="border-bottom: 2px solid #300a3b; padding-bottom: 10px; text-align: right; margin-top: 20px;">{{
        "General
        information" |
        translator }}</h2>
      <table
        style="width: 100%; border-collapse: collapse; margin-top: 20px; direction: rtl; text-align: right; border: 1px solid #eee;">
        <tr *ngFor="let item of (printableData.stats || [])" style="border-bottom: 1px solid #eee;">
          <td style="padding: 10px; font-weight: bold; width: 50%; border: 1px solid #eee;">{{ item.key | translator }}
          </td>
          <td style="padding: 10px; border: 1px solid #eee;">
            {{ getStatValue(item.value) }}
          </td>
        </tr>
      </table>

      <!-- Aggregate Summaries (Assessment Only) -->
      <div *ngIf="printableData.fromLabel === 'assessment'"
        style="display: flex; flex-direction: column; gap: 40px; margin-top: 40px;">

        <!-- 2. Performance Level by Grade (Matching Image 2 Precisely) -->
        <div style="page-break-inside: avoid; margin-top: 30px;">

          <!-- Header Bar (Cleaned, Right Aligned) -->
          <div
            style="border-bottom: 2px solid #300a3b; padding: 12px 20px; display: flex; justify-content: flex-start; align-items: center; direction: rtl;">
            <div style="display: flex; align-items: center; gap: 15px;">
              <h2 style="margin: 0; font-size: 22px; font-weight: bold; color: #2c2f75;">{{ "مستوى الأداء حسب التقدير"
                }}</h2>
            </div>
          </div>

          <!-- Total Examiners and Overall Average Section - TOP -->
          <div style="display: flex; gap: 20px; padding: 20px; background: #fff; direction: rtl; align-items: stretch;">
            
            <!-- Total Examiners Box -->
            <div style="flex: 0 0 auto; text-align: center; padding: 15px 30px; border: 2px solid #eee; border-radius: 8px; background: #fff;">
              <span style="display: block; font-size: 13px; color: #888; margin-bottom: 8px;">إجمالي {{
                printableData.term }}</span>
              <span
                style="font-size: 42px; font-weight: bold; color: #2c2f75; display: inline-block;">
                {{ printableData.totalParticipants }}
              </span>
            </div>

            <!-- Overall Average Table (Compact Style) -->
            <div style="flex: 1;" *ngIf="printableData.allData">
              <table
                style="width: 100%; border-collapse: collapse; border: 2px solid #eee; text-align: center; direction: rtl; color: #000 !important; height: 100%;">
                <thead>
                  <tr style="background: #f8f9fa;">
                    <th style="padding: 8px; border: 1px solid #eee; font-weight: bold; text-align: center; font-size: 13px; color: #888;">
                      {{ "المعدل العام بالنسبة" }}</th>
                    <th style="padding: 8px; border: 1px solid #eee; font-weight: bold; text-align: center; font-size: 13px; color: #888;">
                      {{ "المعدل العام بالدرجة" }}</th>
                    <th style="padding: 8px; border: 1px solid #eee; font-weight: bold; text-align: center; font-size: 13px; color: #888;">
                      {{ "المعدل العام بالتقدير" }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="padding: 12px; border: 1px solid #eee; text-align: center; font-weight: bold; font-size: 18px; color: #2c2f75;">
                      {{ (printableData.allData['Overall average for the assessment in percentage']?.value ?? 0).toFixed(0) }}%
                    </td>
                    <td style="padding: 12px; border: 1px solid #eee; text-align: center; font-weight: bold; font-size: 18px; color: #2c2f75;">
                      {{ (printableData.allData['Overall average for the assessment in marks']?.value ?? 0).toFixed(2) }}
                    </td>
                    <td style="padding: 12px; border: 1px solid #eee; text-align: center; font-weight: bold; font-size: 18px; color: #2c2f75;">
                      {{ (printableData.allData['Overall average for the assessment in grades']?.value ?? '-') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div style="display: flex; gap: 0; align-items: stretch; direction: ltr;">

            <!-- Chart Area (Left side - 68%) -->
            <div style="flex: 0 0 68%; padding: 25px; position: relative; background: #fff;">

              <h4
                style="text-align: center; color: #666; font-size: 18px; margin-bottom: 40px; font-weight: 500; direction: rtl;">
                مستوى أداء {{ printableData.term }} وفقا لسلم الدرجات
              </h4>

              <div style="display: flex; height: 350px; position: relative;">

                <!-- Y-Axis Labels -->
                <div
                  style="display: flex; flex-direction: column; justify-content: space-between; height: 300px; padding-right: 15px; text-align: right; color: #888; font-size: 12px; width: 45px; margin-top: 10px;">
                  <span *ngFor="let label of printableData.yAxisLabels">{{ label }}</span>
                </div>

                <!-- Grid and Bars Container -->
                <div
                  style="flex-grow: 1; position: relative; border-bottom: 2px solid #ccc; height: 310px; margin-top: 10px;">

                  <!-- Horizontal Grid Lines -->
                  <div *ngFor="let label of printableData.yAxisLabels"
                    [style.bottom.%]="(label / (printableData.yAxisMax || 1) * 100)"
                    style="position: absolute; left: 0; right: 0; border-top: 1px solid #eee; z-index: 1;">
                  </div>

                  <!-- Bars -->
                  <div
                    style="display: flex; justify-content: space-around; align-items: flex-end; height: 100%; position: relative; z-index: 2; padding: 0 20px;">
                    <div *ngFor="let item of (printableData.gradeResults || [])"
                      style="display: flex; flex-direction: column; align-items: center; gap: 0; width: 65px; position: relative;">

                      <!-- Badge -->
                      <div *ngIf="item.value > 0"
                        style="background: #fff !important; border: 2px solid #ffb300 !important; color: #333 !important; width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 14px; margin-bottom: 10px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); z-index: 3;">
                        {{ item.value }}
                      </div>

                      <!-- Bar -->
                      <div [style.height.px]="(item.value / (printableData.yAxisMax || 1) * 300)"
                        style="width: 52px; background: #0b1f53 !important; border-radius: 2px 2px 0 0; min-height: 2px; display: block; -webkit-print-color-adjust: exact; print-color-adjust: exact;">
                      </div>

                      <!-- Label -->
                      <span
                        style="font-size: 14px; font-weight: bold; text-align: center; margin-top: 15px; color: #333 !important; direction: rtl;">{{
                        item.label }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Legend -->
              <div
                style="display: flex; align-items: center; justify-content: center; gap: 10px; margin-top: 25px; font-size: 13px; color: #666; direction: rtl;">
                <div style="width: 12px; height: 12px; background: #0b1f53;"></div>
                <span>أعداد {{ printableData.term }} في السلم</span>
              </div>

            </div>

            <!-- Analysis Box (Right side - 32%) -->
            <div
              style="flex: 0 0 32%; background: #fff; padding: 25px; border-left: 1px solid #ddd; display: flex; flex-direction: column; gap: 0; direction: rtl;">
              <div *ngFor="let item of (printableData.gradeResults || [])"
                style="text-align: right; padding: 15px 0; border-bottom: 1px solid #eee; position: relative;">
                <p style="margin: 0; font-size: 14px; line-height: 1.6; color: #333; font-weight: 500;">{{
                  item.analysisText }}</p>
                <!-- Small Blue Arrow Indicator - Points from Chart (Left) to Text (Right) -->
                <div
                  style="position: absolute; left: -25px; top: 50%; transform: translateY(-50%); width: 0; height: 0; border-top: 8px solid transparent; border-bottom: 8px solid transparent; border-right: 10px solid #00a0e9;">
                </div>
              </div>
            </div>

          </div>

          <!-- Grade Scale Footer (Moved Outside to span full width) -->
          <div style="margin-top: 35px; direction: rtl;">
            <h5
              style="text-align: center; font-size: 16px; color: #47276d; margin-bottom: 15px; font-weight: bold;">
              {{ "سلم الدرجات" }}</h5>
            <table style="width: 100%; border-collapse: collapse; text-align: center; font-size: 14px; border: 1px solid #000;">
              <!-- Score Ranges Row -->
              <tr style="height: 35px; background: #fafafa; color: #555;">
                <td *ngFor="let c of (printableData.allData.Criteria?.[0]?.data || [])"
                  style="border: 1px solid #000; padding: 5px;">
                  {{ c.from }} - {{ c.to }}
                </td>
              </tr>
              <!-- Grade Labels Row -->
              <tr style="height: 45px; font-weight: bold; color: #2c2f75;">
                <td *ngFor="let c of (printableData.allData.Criteria?.[0]?.data || [])"
                  style="border: 1px solid #000; padding: 5px; background: #fdfdfd;">
                  {{ c.title }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- Summary Tables (Assessment Only) -->
      <div *ngIf="printableData.fromLabel === 'assessment'"
        style="display: flex; gap: 20px; margin-top: 20px; page-break-inside: avoid;">

        <!-- Summary 1: Performance Levels -->
        <div style="flex: 1;" *ngIf="printableData.summaryData1">
          <table
            style="width: 100%; border-collapse: collapse; border: 1px solid #000; text-align: right; direction: rtl;">
            <thead>
              <tr style="background: #f8f9fa;">
                <th
                  style="border: 1px solid #000; padding: 6px 10px; font-weight: bold; text-align: right; font-size: 14px;">
                  التقدير</th>
                <th
                  style="border: 1px solid #000; padding: 6px 10px; font-weight: bold; text-align: center; font-size: 14px;">
                  عدد المختبرين</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of (printableData.summaryData1 || [])">
                <td style="border: 1px solid #000; padding: 6px 10px; text-align: right; font-size: 14px;">{{ item.label
                  }}</td>
                <td style="border: 1px solid #000; padding: 6px 10px; text-align: center; font-size: 14px;">{{
                  item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Summary 2: Correct/Incorrect -->
        <div style="flex: 1;" *ngIf="printableData.summaryData2">
          <table
            style="width: 100%; border-collapse: collapse; border: 1px solid #000; text-align: right; direction: rtl;">
            <thead>
              <tr style="background: #f8f9fa;">
                <th
                  style="border: 1px solid #000; padding: 6px 10px; font-weight: bold; text-align: right; font-size: 14px;">
                  نوع الإجابة</th>
                <th
                  style="border: 1px solid #000; padding: 6px 10px; font-weight: bold; text-align: center; font-size: 14px;">
                  القيمة</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of (printableData.summaryData2 || [])">
                <td style="border: 1px solid #000; padding: 6px 10px; text-align: right; font-size: 14px;">{{ item.label
                  }}</td>
                <td style="border: 1px solid #000; padding: 6px 10px; text-align: center; font-size: 14px;">{{
                  item.value }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div style="page-break-after: always;"></div>

      <!-- 2. Worst Performing Questions (Exact Replicate of Web UI) -->
      <div class="section-container mb-5" *ngIf="printableData.worstPerformingQuestions?.length > 0"
        style="page-break-after: always; margin-top: 40px; background: #f8f9fa; padding: 40px 20px; border-radius: 15px;">
        <h2 style="text-align: center; margin-bottom: 40px; font-weight: bold; font-size: 24px; color: #333;">الأسئلة التي حصلت على أعلى نسبة من الأخطاء</h2>

        <div style="display: flex; flex-wrap: wrap; gap: 15px; justify-content: center; direction: rtl;">
          <div *ngFor="let q of printableData.worstPerformingQuestions"
            style="flex: 0 0 calc(33.33% - 15px); min-width: 240px; display: flex; flex-direction: column; gap: 8px; page-break-inside: avoid;">

            <!-- Main Stats Card -->
            <div
              style="background: #fff; border: 1px solid #f0f0f0; border-radius: 14px; padding: 30px 20px; display: flex; flex-direction: column; align-items: center; text-align: center; box-shadow: 0 2px 6px rgba(0,0,0,0.02);">
              <!-- Icon (Web Style Clipboard) -->
              <div style="margin-bottom: 12px;">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="1.5">
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                  <rect x="8" y="2" width="8" height="4" rx="1" fill="#fff"></rect>
                  <path d="M12 11h4m-4 4h4m-8-4.5l1 1 2-2"></path>
                </svg>
              </div>

              <h1 style="margin: 0; font-size: 28px; font-weight: bold; color: #444;">{{ q.count - q.correct }}</h1>
              <div style="color: #007bff; font-weight: bold; font-size: 16px; margin: 8px 0;">
                من {{ q.count }} {{ printableData.termSingular }}
              </div>

              <div style="width: 70%; height: 1px; background: #eee; margin: 15px 0;"></div>

              <p style="margin: 0; font-size: 12px; color: #888; line-height: 1.6; font-weight: 400;">
                أخطأوا في السؤال ({{ q.data?.questionText }}) أي ما يعادل {{ (q.count > 0 ? ((q.count - q.correct) / q.count *
                100).toFixed(0) : '0') }}% من جميع {{ printableData.term }}
              </p>
            </div>

            <!-- Correct Answer Box -->
            <div
              style="background: #fff; border: 1px solid #f0f0f0; border-radius: 14px; padding: 15px; text-align: center; font-size: 14px; font-weight: bold; color: #444; box-shadow: 0 2px 6px rgba(0,0,0,0.02);">
              <span style="color: #888; font-weight: normal;">الخيار الصحيح:</span>
              <span style="margin-right: 8px;">{{ q.data?.meta?.correct || '-' }}</span>
            </div>

          </div>
        </div>
      </div>

      <!-- 3. Question Analysis Section -->
      <div class="section-container">
        <div *ngFor="let g of printableData.graphData; let i = index"
          style="margin-bottom: 60px; page-break-after: always;">
          <!-- Header on every page -->
          <div class="pdf-header"
            style="display: flex; justify-content: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 30px;">
            <div style="font-weight: bold; font-size: 1.2rem;">{{ printableData.assessmentName }} | {{
              printableData.date }}</div>
          </div>

          <h1 *ngIf="i === 0"
            style="text-align: center; margin-bottom: 30px; margin-top: 20px; font-weight: bold; font-size: 2.3rem;">
            {{ "تحليل النتائج على مستوى الأسئلة" }}
          </h1>

          <!-- Section Heading (Type Info) -->
          <div *ngIf="g.type === 'info'" 
            style="background: #47276d; color: #fff; padding: 20px; border-radius: 8px; text-align: center; margin-bottom: 40px; margin-top: 20px;">
            <h1 style="margin: 0; font-size: 2rem; color: #fff !important;" [innerHTML]="g.questionText"></h1>
          </div>

          <ng-container *ngIf="g.type !== 'info'">
          <h2 style="font-weight: bold; margin-bottom: 20px; text-align: right; font-size: 1.4rem; direction: rtl;">
            <span>{{ g.qIndex }}: </span><span [innerHTML]="g.questionText"></span>
          </h2>

            <!-- Question Chart Image (for OU and other chart types); OU question: chart only, no table below -->
            <div style="text-align: center; margin-bottom: 20px;" *ngIf="g.chartImage">
              <img [src]="g.chartImage" style="max-width: 90%; height: auto; border: 1px solid #eee;">
            </div>

            <!-- For OU_TREE_DROPDOWN: render chart (if present) plus the type='text' answers table; skip other tables -->
            <ng-container *ngIf="g.questionType !== 'OU_TREE_DROPDOWN' || g.type === 'text'">
          <!-- Question Type: Bar or Pie Content -->
          <div *ngIf="g.type === 'bar' || g.type === 'pie'">
            <table
              style="width: 100%; border-collapse: collapse; margin-bottom: 30px; text-align: center; border: none;">
              <thead>
                <tr style="border-bottom: 4px solid #000;">
                  <th *ngFor="let label of (g.graphData?.labels || [])"
                    style="padding: 10px; font-weight: bold; border: none;">{{ label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td *ngFor="let val of (g.graphData?.datasets?.[0]?.data || [])"
                    style="padding: 15px; font-weight: bold; font-size: 1.3rem; border: none;">
                    {{ val }}{{ g.type === 'bar' ? '%' : '' }}
                  </td>
                </tr>
                <tr *ngIf="g.graphData?.datasets?.[0]?.counts">
                  <td *ngFor="let count of (g.graphData?.datasets?.[0]?.counts || [])"
                    style="padding: 10px; font-size: 1rem; color: #661; border-top: 1px solid #f0f0f0;">
                    <small style="display:block; color:#999;">{{ "عدد" }} {{ printableData.term }}</small>
                    <strong>{{ count }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Question Type: Open Text (and OU_TREE_DROPDOWN) -->
          <div *ngIf="g.type === 'text'">
            <table
              style="width: 100%; border-collapse: collapse; text-align: right; direction: rtl; border: 1px solid #000;">
              <thead>
                <tr style="background: #f8f9fa;">
                  <th *ngFor="let col of (g.data?.labels || [])"
                    style="border: 1px solid #000; padding: 10px; font-weight: bold;">
                    {{ col }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rowData of getTextTableRows(g)">
                  <ng-container *ngFor="let val of rowData">
                    <td *ngIf="val != '' && val != null" style="border: 1px solid #000; padding: 10px;">
                      {{ val }}
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Question Type: Matrix/Nested Table -->
          <div *ngIf="g.type === 'table'">
            <table
              style="width: 100%; border-collapse: collapse; text-align: center; direction: rtl; border: 1px solid #000;">
              <thead>
                <tr style="background: #f8f9fa;">
                  <th style="border: 1px solid #000; padding: 10px;"></th>
                  <th *ngFor="let col of (g.data?.labels || [])"
                    style="border: 1px solid #000; padding: 10px; font-weight: bold;">
                    {{ col && col[0] && col.length === 1 ? col[0] : col }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of g.data.datasets">
                  <td
                    style="border: 1px solid #000; padding: 10px; font-weight: bold; background: #fdfdfd; text-align: right;">
                    {{ row.label }}
                  </td>
                  <td *ngFor="let val of row.data" style="border: 1px solid #000; padding: 10px;">{{ val }}{{
                    printableData.fromLabel === 'survey' ? '' : '%' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Question Type: Emoticon (Smile) -->
          <div *ngIf="g.type === 'smile'">
            <table
              style="width: 100%; border-collapse: collapse; text-align: center; direction: rtl; border: 1px solid #000;">
              <thead>
                <tr style="background: #f8f9fa;">
                  <th style="border: 1px solid #000; padding: 10px; font-weight: bold;">{{ "Label" | translator }}</th>
                  <th style="border: 1px solid #000; padding: 10px; font-weight: bold;">{{ "Count" | translator }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of g.graphData">
                  <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ item.label | translator }}
                  </td>
                  <td style="border: 1px solid #000; padding: 10px;">{{ item.count }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Question Type: Rating (Star) -->
          <div *ngIf="g.type === 'rate'">
            <table
              style="width: 100%; border-collapse: collapse; text-align: center; direction: rtl; border: 1px solid #000;">
              <thead>
                <tr style="background: #f8f9fa;">
                  <th style="border: 1px solid #000; padding: 10px; font-weight: bold;">{{ "Label" | translator }}</th>
                  <th style="border: 1px solid #000; padding: 10px; font-weight: bold;">{{ "Average Rating" | translator
                    }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of g.graphData">
                  <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ item.label | translator }}
                  </td>
                  <td style="border: 1px solid #000; padding: 10px;">{{ item.value }} / 5</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Question Type: Ranking (Rank Order / Drag Drop) -->
          <div *ngIf="g.type === 'rank_order'">
            <table
              style="width: 100%; border-collapse: collapse; text-align: center; direction: rtl; border: 1px solid #000;">
              <thead>
                <tr style="background: #f8f9fa;">
                  <th style="border: 1px solid #000; padding: 10px; font-weight: bold;">{{ "Item" | translator }}</th>
                  <th *ngFor="let r of g.data.ranks" style="border: 1px solid #000; padding: 10px; font-weight: bold;">
                    {{ "Rank" | translator }} {{ r }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let label of g.data.labels">
                  <td style="border: 1px solid #000; padding: 10px; text-align: right; font-weight: bold;">{{ label }}
                  </td>
                  <td *ngFor="let r of g.data.ranks" style="border: 1px solid #000; padding: 10px;">
                    {{ g.data.distribution[label][r] || 0 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Question Type: Calendar -->
          <div *ngIf="g.type === 'calander'">
            <table
              style="width: 100%; border-collapse: collapse; text-align: right; direction: rtl; border: 1px solid #000;">
              <thead>
                <tr style="background: #f8f9fa;">
                  <th style="border: 1px solid #000; padding: 10px; font-weight: bold;">{{ "Selected Dates" | translator
                    }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of g.meta">
                  <td style="border: 1px solid #000; padding: 10px;">{{ formatDate(row.value) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Correct Answer Text -->
          <!-- <div *ngIf="g.correctAnswerText != null && g.correctAnswerText !== ''" style="background: #eafbea; border: 1px solid #c3e6cb; border-radius: 8px; padding: 15px; text-align: right; font-size: 1.1rem; font-weight: bold; color: #155724; margin-top: 20px;">
            <span style="color: #444; font-weight: normal; margin-left: 8px;">الخيار الصحيح:</span>
            <span>{{ g.correctAnswerText }}</span>
          </div> -->


            </ng-container>
          </ng-container>


        </div>

      </div>

      <!-- 4. Participant Information -->
      <div *ngIf="!printableData.isAnonymous" class="section-container" style="page-break-before: always;">
        <div class="pdf-header"
          style="display: flex; justify-content: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 30px;">
          <div style="font-weight: bold; font-size: 1.2rem;">{{ printableData.assessmentName }} | {{
            printableData.date }}</div>
        </div>
        <h1 style="text-align: center; margin-bottom: 50px; font-weight: bold; font-size: 2.5rem; margin-top: 20px;">
          معلومات {{ printableData.term }}
        </h1>
        <table style="width: 100%; border-collapse: collapse; border: 2px solid #000;">
          <thead>
            <tr style="background: #f8f9fa;">
              <!-- Ordered for RTL: Name, Email, Score, Percentage, Grade -->
              <th style="border: 1px solid #000; padding: 10px; font-weight: bold; text-align: right;">{{ "الاسم" }}
              </th>
              <th style="border: 1px solid #000; padding: 10px; font-weight: bold; text-align: center;">{{ "البريد
                الإلكتروني" }}</th>
              <th *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; font-weight: bold; text-align: center;">
                {{ "الدرجة الحاصل عليها" }}
              </th>
              <th *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; font-weight: bold; text-align: center;">
                {{ "الدرجة الكلية" }}
              </th>
              <th *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; font-weight: bold; text-align: center;">{{ "النسبة" }}
              </th>
              <th *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; font-weight: bold; text-align: center;">{{ "التقدير" }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of printableData.results">
              <td style="border: 1px solid #000; padding: 10px; text-align: right;">{{ p.resolvedName }}</td>
              <td style="border: 1px solid #000; padding: 10px; text-align: center;">{{ p.email || '-' }}</td>
              <td *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; text-align: center;">
                {{ +p.score?.toFixed(2) }}
              </td>
              <td *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; text-align: center;">
                {{ +p.totalMarks?.toFixed(2) }}
              </td>
              <td *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; text-align: center;">{{ p.percentage?.toFixed(0) || '0'
                }}%
              </td>
              <td *ngIf="printableData.fromLabel === 'assessment'"
                style="border: 1px solid #000; padding: 10px; text-align: center;">{{ p.criteria || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

  <button id="print-results-btn"
    [printStyle]="{'@page': {'size': 'auto', 'margin': '0mm'}, '#printable-area':{'padding': '15mm', 'display':'block', 'color': '#000 !important', 'background': '#fff !important'}, '*':{'direction': 'rtl', 'font-family': 'DINNextLTArabic', 'color': '#000 !important'}}"
    printSectionId="printable-area" ngxPrint [useExistingCss]="true" [printTitle]="printableData.assessmentName"
    style="display: none;">
  </button>